export default __webpack_public_path__ + "static/media/referrals.004f3d89.png";